"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _q = _interopRequireDefault(require("q"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _QuotaRecord = _interopRequireDefault(require("../records/QuotaRecord"));

var _quotaUtils = require("../utils/quotaUtils");

var _apiUtils = require("../utils/apiUtils");

var _Constants = require("../Constants");

var BASE_URL = 'quotas/v1';

function chunkList(list, chunkSize) {
  return list.reduce(function (chunks, item) {
    if (chunks.isEmpty() || chunks.last().size === chunkSize) {
      chunks = chunks.push((0, _immutable.List)());
    }

    return chunks.update(chunks.size - 1, function (chunk) {
      return chunk.push(item);
    });
  }, (0, _immutable.List)());
}

var QuotasApi =
/*#__PURE__*/
function () {
  function QuotasApi() {
    (0, _classCallCheck2.default)(this, QuotasApi);
  }

  (0, _createClass2.default)(QuotasApi, null, [{
    key: "getQuotas",
    value: function getQuotas(_ref) {
      var quotaType = _ref.quotaType,
          period = _ref.period,
          year = _ref.year;
      var data1 = {
        query: {
          objectType: 'QUOTA',
          allPropertiesFetchMode: 'latest_version',
          year: year
        }
      };
      var data2 = {
        query: {
          objectType: 'QUOTA',
          allPropertiesFetchMode: 'latest_version',
          year: year + 1
        }
      };
      return _q.default.Promise.all([_apiClient.default.get(BASE_URL + "/fetcher/" + quotaType + "/" + period, data1), _apiClient.default.get(BASE_URL + "/fetcher/" + quotaType + "/" + period, data2)]).then(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
            thisYear = _ref3[0],
            nextYear = _ref3[1];

        return thisYear.concat(nextYear);
      });
    }
  }, {
    key: "postQuotas",
    value: function postQuotas(quotas) {
      if (quotas.isEmpty()) {
        return _q.default.Promise.resolve([]);
      }

      var timestamp = _I18n.default.moment().valueOf();

      var postRequests = chunkList(quotas, 100).map(function (quotaList) {
        return _apiClient.default.post(BASE_URL + "/quotas/batch", {
          data: quotaList.map(function (quota) {
            return (0, _apiUtils.transformQuotaDataForPost)(quota, timestamp);
          }).toArray()
        });
      });
      return _q.default.Promise.all(postRequests.toJS()).then(function (results) {
        return results.reduce(function (allResults, cur) {
          return allResults.concat(cur);
        }, []);
      });
    }
  }, {
    key: "updateQuotas",
    value: function updateQuotas(_ref4) {
      var quotas = _ref4.quotas,
          attributesToUpdate = _ref4.attributesToUpdate;

      if (quotas.isEmpty()) {
        return _q.default.Promise.resolve({
          updatedQuotas: [],
          originalQuotasById: {}
        });
      }

      var timestamp = _I18n.default.moment().valueOf();

      var putRequests = chunkList(quotas, 100).map(function (quotaList) {
        return _apiClient.default.put(BASE_URL + "/quotas/batch", {
          data: quotaList.map(function (quota) {
            return (0, _apiUtils.transformQuotaDataForPut)(quota, attributesToUpdate, timestamp);
          }).toArray()
        });
      });
      return _q.default.Promise.all(putRequests.toJS()).then(function (results) {
        return {
          updatedQuotas: results.reduce(function (allResults, cur) {
            return allResults.concat(cur);
          }, []),
          originalQuotasById: quotas.reduce(function (quotasById, quota) {
            return quotasById.set(quota.id, quota);
          }, (0, _immutable.Map)())
        };
      });
    }
  }, {
    key: "saveQuotas",
    value: function saveQuotas(_ref5) {
      var quotasToAdd = _ref5.quotasToAdd,
          quotasToUpdate = _ref5.quotasToUpdate,
          attributesToUpdate = _ref5.attributesToUpdate;
      return _q.default.Promise.all([QuotasApi.postQuotas(quotasToAdd), QuotasApi.updateQuotas({
        quotas: quotasToUpdate,
        attributesToUpdate: attributesToUpdate
      })]).then(function (_ref6) {
        var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
            postResult = _ref7[0],
            updateResult = _ref7[1];

        return {
          postResult: postResult,
          updateResult: updateResult
        };
      });
    }
  }, {
    key: "deleteQuotas",
    value: function deleteQuotas(quotasToDelete) {
      // TODO: make deleting batches of > 100 less hacky
      var deleteRequests = chunkList(quotasToDelete, 100).map(function (quotaList) {
        return _apiClient.default.delete(BASE_URL + "/quotas/batch", {
          query: {
            id: quotaList.toArray().map(function (quota) {
              return quota.id;
            })
          }
        });
      });
      return _q.default.Promise.all(deleteRequests.toJS()).then(function () {
        return quotasToDelete;
      });
    }
  }, {
    key: "addQuotaRows",
    value: function addQuotaRows(_ref8) {
      var accessType = _ref8.accessType,
          period = _ref8.period,
          quotaType = _ref8.quotaType,
          rows = _ref8.rows,
          year = _ref8.year;
      var dates = accessType === _Constants.ACCESS_TYPES.BASIC_SALES ? (0, _quotaUtils.getBasicGoalsDates)() : (0, _quotaUtils.getDatesForTwoYears)(year, period);
      var quotas = dates.reduce(function (quotaRecords, startDate) {
        return quotaRecords.concat(rows.map(function (_ref9) {
          var ownerId = _ref9.ownerId,
              pipelineId = _ref9.pipelineId;
          return new _QuotaRecord.default({
            quotaType: quotaType,
            pipelineId: pipelineId,
            ownerId: ownerId,
            period: period,
            value: 0,
            startDate: startDate,
            endDate: (0, _quotaUtils.getEndOfPeriod)(startDate)
          });
        }));
      }, (0, _immutable.List)());
      return QuotasApi.saveQuotas({
        quotasToAdd: quotas,
        quotasToUpdate: (0, _immutable.List)(),
        attributesToUpdate: (0, _immutable.Map)()
      });
    }
  }, {
    key: "updateQuotaRowPipeline",
    value: function updateQuotaRowPipeline(_ref10) {
      var quotasRowRecord = _ref10.quotasRowRecord,
          newPipelineId = _ref10.newPipelineId;
      var quotas = quotasRowRecord.quotasByStart.valueSeq();

      if (quotas.isEmpty()) {
        return _q.default.Promise.resolve({
          quotasRowRecord: quotasRowRecord,
          newPipelineId: newPipelineId
        });
      }

      return QuotasApi.saveQuotas({
        quotasToAdd: (0, _immutable.List)(),
        quotasToUpdate: quotas,
        attributesToUpdate: (0, _immutable.Map)({
          pipelineId: newPipelineId
        })
      });
    }
  }, {
    key: "deleteQuotaRows",
    value: function deleteQuotaRows(quotasRowRecordList) {
      var quotas = quotasRowRecordList.reduce(function (quotasList, quotasRowRecord) {
        return quotasList.concat(quotasRowRecord.quotasByStart.valueSeq());
      }, (0, _immutable.List)());

      if (quotas.isEmpty()) {
        return _q.default.Promise.resolve(quotasRowRecordList);
      }

      return QuotasApi.deleteQuotas(quotas);
    }
  }]);
  return QuotasApi;
}();

exports.default = QuotasApi;
module.exports = exports.default;